import FetchPostDataWithAuthNEW from "../services/FetchPostDataWithAuthNEW";

export default async function FechPostAddSmsDraft(club, body) {

  var url = "/sms_api/add_sms_reservation_draft/" + club;
  var data = await FetchPostDataWithAuthNEW(url, body)

  return data;
}